/** Copy for the Archived view (#872). One place so the component and the tests agree. */
export const WIKI_ARCHIVED_COPY = Object.freeze({
    title: 'Archived',
    subtitleAdmin: 'Archived categories and pages are hidden from everyone. Restore puts them back where they were.',
    subtitleEditor: 'Archived pages you can edit. Restore puts them back where they were.',
    noAccessTitle: 'Only editors and admins see archived content',
    noAccessBody: 'Ask a Wiki admin if something you need was archived.',
    loading: 'Loading archived content…',
    categoriesTitle: 'ARCHIVED CATEGORIES',
    categoriesEmpty: 'No archived categories.',
    pagesTitle: 'ARCHIVED PAGES',
    pagesEmpty: 'No archived pages.',
    restore: 'Restore',
    restoring: 'Restoring…',
    archivedOn: (date) => (date ? `Archived ${date}` : 'Archived'),
    insideOf: (parentName) => `In ${parentName}`,
    insideArchived: (subName, parentName) => `${subName} is archived too. Restore ${parentName} first.`,
    restoreLocationFirst: (where) => `Its category is archived. Restore ${where || 'the category'} first.`,
    askAdminLocation: 'Its category is archived. Ask a Wiki admin to restore it.',
});
